import React from "react";
import View from "common/View";
import SetCurrentTimeAndTimezone from "./Settings";

export const DateAndTimeAdmin = () =>
  <View
    className="container-lg"
    title="System Date & Time"
  >
    <SetCurrentTimeAndTimezone />
  </View>

export default DateAndTimeAdmin;
